import React, { useState } from 'react';
import { SearchIcon, MapPinIcon, NavigationIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { BottomNav } from '../components/BottomNav';
import { Input } from '../components/Input';
import { Button } from '../components/Button';
import { useApp } from '../context/AppContext';
import { DriverToggle } from '../components/DriverToggle';
export const Directory: React.FC = () => {
  const navigate = useNavigate();
  const {
    directoryItems,
    setCurrentRide
  } = useApp();
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState<string>('all');
  const categories = [{
    id: 'all',
    label: 'All',
    icon: '🌟'
  }, {
    id: 'food',
    label: 'Food',
    icon: '🍜'
  }, {
    id: 'shopping',
    label: 'Shopping',
    icon: '🛍'
  }, {
    id: 'attractions',
    label: 'Attractions',
    icon: '📸'
  }, {
    id: 'essentials',
    label: 'Essentials',
    icon: '🛒'
  }, {
    id: 'culture',
    label: 'Culture',
    icon: '🕌'
  }, {
    id: 'picks',
    label: 'Local Picks',
    icon: '✨'
  }];
  const filteredItems = directoryItems.filter(item => {
    const matchesSearch = item.name.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = selectedCategory === 'all' || item.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });
  const handleBookRide = (item: (typeof directoryItems)[0]) => {
    setCurrentRide({
      dropoff: item.location
    });
    navigate('/ride-options');
  };
  return <div className="min-h-screen bg-background pb-16" data-id="element-230">
      <div className="p-6" data-id="element-231">
        <div className="flex items-center justify-between mb-6" data-id="element-232">
          <h1 className="text-2xl font-semibold" data-id="element-233">Travel Directory</h1>
          <DriverToggle data-id="element-234" />
        </div>
        <div className="mb-6" data-id="element-235">
          <Input icon="search" placeholder="Search places..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-236" />
        </div>
        <div className="flex overflow-x-auto space-x-3 pb-4 mb-6 -mx-1 px-1" data-id="element-237">
          {categories.map(category => <button key={category.id} className={`flex-shrink-0 px-4 py-2 rounded-lg border ${selectedCategory === category.id ? 'border-primary bg-primary bg-opacity-10' : 'border-white border-opacity-20'}`} onClick={() => setSelectedCategory(category.id)} data-id="element-238">
              <span className="mr-2" data-id="element-239">{category.icon}</span>
              <span className={selectedCategory === category.id ? 'text-primary' : ''} data-id="element-240">
                {category.label}
              </span>
            </button>)}
        </div>
        <div className="space-y-4" data-id="element-241">
          {filteredItems.map(item => <div key={item.id} className="card" data-id="element-242">
              <div className="flex mb-3" data-id="element-243">
                <img src={item.image} alt={item.name} className="w-24 h-24 rounded-lg object-cover mr-3" data-id="element-244" />
                <div className="flex-1" data-id="element-245">
                  <h3 className="font-semibold mb-1" data-id="element-246">{item.name}</h3>
                  <p className="text-sm text-white text-opacity-70 mb-2" data-id="element-247">
                    {item.description}
                  </p>
                  <div className="flex items-center text-xs text-white text-opacity-60" data-id="element-248">
                    <NavigationIcon size={12} className="mr-1 text-primary" data-id="element-249" />
                    <span data-id="element-250">{item.distance}</span>
                    <span className="mx-2" data-id="element-251">•</span>
                    <span data-id="element-252">
                      {item.location.country === 'MY' ? 'Malaysia' : 'Singapore'}
                    </span>
                  </div>
                </div>
              </div>
              <Button variant="secondary" className="py-2" onClick={() => handleBookRide(item)} data-id="element-253">
                <MapPinIcon size={16} className="mr-2" data-id="element-254" />
                Book Ride Here
              </Button>
            </div>)}
        </div>
        {filteredItems.length === 0 && <div className="text-center py-12" data-id="element-255">
            <p className="text-white text-opacity-70" data-id="element-256">No places found</p>
          </div>}
      </div>
      <BottomNav data-id="element-257" />
    </div>;
};